<template>
  <div
    class="c--shared_user-box display-flex align-items-center justify-content-start px-20 px-md-30 py-20 py-md-30 bg-white"
  >
    <h3 class="typo-h3 typo-md-h2 mb-0 display-flex flex-column justify-content-center align-items-start">
      <span data-testid="account-name">{{ userName }} </span>
      <template v-if="userRankTitle">
        <span class="typo-checkbox typo-md-p font-weight-normal color-text-secondary mt-10">{{ userRankTitle }}</span>
      </template>
    </h3>
    <template v-if="userRanImageUrl">
      <Badge :image-url="userRanImageUrl" class="ltr:tw-ml-auto rtl:tw-mr-auto" />
    </template>
  </div>
</template>

<script>
  import Badge from '~/components/loyalty-program/badge.vue'

  export default {
    name: 'UserBox',
    components: {
      Badge,
    },
    props: {
      userName: {
        type: String,
        required: true,
      },
      userRankTitle: {
        type: [Object, String],
        required: false,
        default: null,
      },
      userRanImageUrl: {
        type: [Object, String],
        required: false,
        default: null,
      },
    },
  }
</script>
